(function () {
  'use strict';

  // Live-update the "Select Color: <value>" label when a swatch is chosen.
  function updateLabel(input) {
    if (!input || !input.classList || !input.classList.contains('product-variant__input')) return;
    if (!input.checked) return;
    var wrap = input.closest('.product-variant');
    if (!wrap) return;
    var valueEl = wrap.querySelector('[data-selected-color-value]');
    if (valueEl) {
      valueEl.textContent = input.value;
    }
  }

  document.addEventListener('change', function (e) {
    updateLabel(e.target);
  });

  // Also handle clicks (some themes toggle without a change event firing reliably)
  document.addEventListener('click', function (e) {
    var label = e.target.closest('.product-variant__label');
    if (!label) return;
    var input = document.getElementById(label.getAttribute('for'));
    // Defer so the radio state has settled
    requestAnimationFrame(function () { updateLabel(input); });
  });
})();
